export default __webpack_public_path__ + "static/Tab-size-detail-427b3aa81b5cf08bc0bf6cd52bdc6652.png";